export class TableColumnMeta {
  /**
   * @var {BaseCellRender}
   */
  cellRender;

  /**
   * @var  {string}
   */
  tooltip;

  /**
   * @var {?HeaderTooltipConfig}
   */
  headerTooltipConfig;

  /**
   * @var {boolean}
   */
  isCustomHeaderRender;

  constructor(meta = {}) {
    this.cellRender = meta.cellRender || {};
    this.tooltip = meta.tooltip || null;
    this.headerTooltipConfig = meta.headerTooltipConfig || null;
    this.isCustomHeaderRender = meta.isCustomHeaderRender || false;
  }
}
